import { parseDataTransform, uploadFile } from '@acme/common'
import { Grid } from '@mui/material'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias'
import { SubmitHandler } from 'react-hook-form'
import { Abono, abonos, createAbonoSchema } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormNovoAbono from 'templates/ManutencaoDoPonto/Digitacao/forms/NovoAbono'
import LancamentosAnteriores from '../lancamentos-anteriores'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

const baseUrl = import.meta.env.VITE_BASE_URL

export default function AdicionarAbonoModal() {
    const { mutateAsync, isLoading } = abonos.mutations.useCreate()

    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)

    const { data } = useAusenciasOutletContext()
    const rows = data
        ?.filter(({ tipoAusencia }) => tipoAusencia === ('Abono' as any))
        ?.filter(item => item.funcionarioId == funcionarioId)

    const handleSubmit: SubmitHandler<Abono> = async ({ fileUrl, ...data }) => {
        const filename = await uploadFile(fileUrl!, baseUrl)
        const json = {
            ...parseDataTransform(data),
            funcionarioId,
            empresaId,
            fileUrl: filename,
            origem: 1,
            tipo: data.tipo || 'NORMAL',
        } as Abono
        await mutateAsync(json, {
            onSuccess: async () => {
                await invalidateAusenciasQuery()
                toast.success('Abono adicionado com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={{ tipo: 'NORMAL' }}
            schema={createAbonoSchema}
            open={hasPermission(['create', 'Abonos'])}
        >
            <Dialog.Title>Novo abono</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6}>
                        <SelectEmpresa width="100%" size="medium" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SelectFuncionario width="100%" size="medium" />
                    </Grid>
                </Grid>
                <FormNovoAbono />
                <LancamentosAnteriores rows={rows} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
